import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import FullCalendar from "@fullcalendar/react";
import timeGridPlugin from "@fullcalendar/timegrid";
import axios from "axios";
import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { fetchCmsMetaData } from "../../../Components/Utility/cmsMetaService";
import { SetMetaTags } from "../../../Components/Utility/setMetaTags";
import EventDetailModal from "../Model/EventDetailModal";

function ExperienceCalender() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [currentMonth, setCurrentMonth] = useState("");
  const [pendingMonth, setPendingMonth] = useState(null);
  const [total, setTotal] = useState(null);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
const [baseURL, setBaseURl] = useState(null);
  const [meta,setMeta] = useState();

  const token = localStorage.getItem("authToken");
  const apiBase = process.env.REACT_APP_API_BASE;

 const fetchEvents = async (month, weekRange = null) => {
  if (!month) return;
  setLoading(true);

  try {
    let url = `${apiBase}/host/calendar-bookings?month=${month}`;

    // ✅ Add week range if available (week_from & week_to)
    if (weekRange) {
      url += `&week_from=${weekRange.start}&week_to=${weekRange.end}`;
    }


    const res = await axios.get(url, {
      headers: { Authorization: `Bearer ${token}` },
    });

    const totalValue = res.data?.total;
    setTotal(totalValue);
    const bookings = res.data.data || [];
    const baseURl = res.data?.base_url;
    setTotal(totalValue);
    setBaseURl(baseURl);

    // ✅ Group bookings
    const groupedBookings = Object.values(
      bookings.reduce((acc, curr) => {
        const key = `${curr.experience_id}_${curr.host_id}_${curr.booking_date}_${curr.booking_from_time}_${curr.booking_to_time}`;
        if (!acc[key]) {
          acc[key] = {
            ...curr,
            total_guest_count: curr.guest_count || 0,
            total_child_count: curr.children_count || 0,
            total_infant_count: curr.infants_count || 0,
            combined_total_price: curr.total_price || 0,
            // members: [`${curr.user_first_name} ${curr.user_last_name}`.trim()],
            members: [{
  name: `${curr.user_first_name} ${curr.user_last_name}`.trim(),
  adults: curr.guest_count || 0,
  children: curr.children_count || 0,
  infants: curr.infants_count || 0
}],

          };
        } else {
          acc[key].total_guest_count += curr.guest_count || 0;
          acc[key].total_child_count += curr.children_count || 0;
          acc[key].total_infant_count += curr.infants_count || 0;
          acc[key].combined_total_price += curr.total_price || 0;
          // acc[key].members.push(`${curr.user_first_name} ${curr.user_last_name}`.trim());
          acc[key].members.push({
  name: `${curr.user_first_name} ${curr.user_last_name}`.trim(),
  adults: curr.guest_count || 0,
  children: curr.children_count || 0,
  infants: curr.infants_count || 0
});

        }
        return acc;
      }, {})
    );

    setEvents(groupedBookings.length ? groupedBookings : []);
    setCurrentMonth(month);
  } catch (e) {
    console.error(e);
    setError(e.response?.data?.message || "Failed to fetch events");
  } finally {
    setLoading(false);
  }
};


  // ✅ Initial month load
  useEffect(() => {
    const now = new Date();
    const monthStr = now.toISOString().slice(0, 7);
    setCurrentMonth(monthStr);
    fetchEvents(monthStr);
  }, []);

  // // ✅ When user changes calendar month → trigger fetch
  // const handleDatesSet = (arg) => {
  //   const monthStr = arg.start.toISOString().slice(0, 7);
  //   if (monthStr !== currentMonth && !loading) {
  //     setPendingMonth(monthStr);
  //   }
  // };

const handleDatesSet = (arg) => {
  if (arg.view.type === "timeGridWeek") {
    // Use local date parts instead of UTC (avoid toISOString)
    const start = new Date(arg.start);
    const end = new Date(arg.end);

    // FullCalendar's `end` is exclusive → subtract 1 day to make inclusive
    end.setDate(end.getDate() - 1);

    // Format YYYY-MM-DD in LOCAL time
    const formatLocalDate = (d) => {
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };

    const weekFrom = formatLocalDate(start);
    const weekTo = formatLocalDate(end);

    // Pick middle date for month detection
    const middleDate = new Date(
      start.getTime() + (end.getTime() - start.getTime()) / 2
    );
    const monthStr = `${middleDate.getFullYear()}-${String(
      middleDate.getMonth() + 1
    ).padStart(2, "0")}`;


    fetchEvents(monthStr, { start: weekFrom, end: weekTo });
  } else {
    // Month view
    const middleDate = new Date(
      arg.start.getTime() + (arg.end.getTime() - arg.start.getTime()) / 2
    );
    const monthStr = `${middleDate.getFullYear()}-${String(
      middleDate.getMonth() + 1
    ).padStart(2, "0")}`;

    // if (monthStr !== currentMonth && !loading) {
    //   fetchEvents(monthStr);
    // }
     if (!loading) {
      fetchEvents(monthStr);
    }
  }
};







  // ✅ Fetch when month changes, but keep old events visible until done
  useEffect(() => {
    if (pendingMonth) {
      fetchEvents(pendingMonth);
      setPendingMonth(null);
    }
  }, [pendingMonth]);

  // ✅ Prepare FullCalendar events
  const fcEvents = useMemo(
    () =>
      (events || [])
        .map((ev) => {
          if (!ev.booking_date || !ev.booking_from_time || !ev.booking_to_time)
            return null;
           let className = "";
        if (ev.status === 1) className = "status-confirmed";
        if (ev.status === 0) className = "status-pending";
        if (ev.status === 2) className = "status-cancelled";
          return {
            id: ev.id || ev._id,
            title: `${ev.experience_title} — ${ev.members.length} members`,
            start: `${ev.booking_date}T${ev.booking_from_time}`,
            end: `${ev.booking_date}T${ev.booking_to_time}`,
            classNames: [className],
            extendedProps: {
              baseURL: baseURL,
              image: ev.image,
              experience_title: ev.experience_title,
              experience_id: ev.experience_id,
              date: ev.booking_date,
              time: `${ev.booking_from_time} - ${ev.booking_to_time}`,
              members: ev.members,
              experience_url_slug:ev.experience_url_slug
            },
          };
        })
        .filter(Boolean),
    [events]
  );

  // ✅ Tooltip on hover
  const eventDidMount = (info) => {
    const { experience_title, members } = info.event.extendedProps;
    info.el.title = `${experience_title}\nMembers: ${members.length}`;
  };

  // ✅ Event click → open modal
  const handleEventClick = (clickInfo) => {
    setSelectedEvent(clickInfo.event);
    setIsModalOpen(true);
  };

  useEffect(() => {
    const loadMeta = async () => {
      const data = await fetchCmsMetaData("calender");
      setMeta(data);
    };

    loadMeta();
  }, []);

  return (
    <div className="calensdders_areea al_bootm_spance" style={{ position: "relative" }}>

       <SetMetaTags
        title= {meta?.meta_title || "Calender | Weyfarin"}
        description={meta?.meta_description || "Calender | Weyfarin"}
      
      />
      {/* ✅ Optional Loading Overlay */}
      {loading && (
        <div
          style={{
            position: "absolute",
            inset: 0,
            background: "rgba(255,255,255,0.7)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 10,
            fontWeight: "500",
          }}
        >
          Loading calendar...
        </div>
      )}

      {!loading && total === 0 ? (
        <div className="ser_v_araeea allpages dashboardpgs Calender">
          <div className="container">
            <div className="calenddres">
              {/* <div className="td_upcmings">
                <a href="#" className="actcler">
                  Today
                </a>
                <a href="#">Upcoming</a>
              </div> */}
              <div className="btm_ar_contents td_upcmings">
                <h4>You don’t have any reservations</h4>
                <p>
                  Your experience won’t appear in search results and can’t be
                  booked. Relist to start earning.
                </p>
                <Link to={"/listing"}>Go to listings</Link>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="card">
          <FullCalendar
            plugins={[timeGridPlugin, dayGridPlugin, interactionPlugin]}
            initialView="dayGridMonth"
            headerToolbar={{
              left: "dayGridMonth",
              center: "title",
              right: "timeGridWeek",
            }}
            footerToolbar={{
              left: "",
              center: "prev,next",
              right: "",
            }}
            height="75vh"
            nowIndicator={true}
            slotMinTime={"01:00:00"}
            slotMaxTime={"24:00:00"}
            events={fcEvents}
            eventDidMount={eventDidMount}
            datesSet={handleDatesSet}
            eventClick={handleEventClick}
            displayEventTime={false}
            
          />

          {isModalOpen && selectedEvent && (
            <EventDetailModal
              event={selectedEvent}
              onClose={() => {
                setIsModalOpen(false);
                setSelectedEvent(null);
              }}
            />
          )}
        </div>
      )}
    </div>
  );
}

export default ExperienceCalender;
